import { useI18N } from '@yandex-int/i18n/lib/react';

import i18n from '@yandex-int/i18n';
import { displayUserAgreements } from 'client/utils';
import * as appFormKeyset from 'i18n/AppForm';
import * as appKeyset from 'i18n/AppsIndex';
import * as draftControlKeyset from 'i18n/DraftControlPanel';
import * as keyset from 'i18n/Settings';

import { routes } from '../lib/routes';
import { MarkedMenuItem } from '../model/menu-item';
import { AliceApp, Channel } from '../model/skill';

import { useMenuItems } from './useMenuItems';

type SettingsTab = 'main' | 'devices' | 'intents' | 'userAgreements';

const tDraftControl = i18n(draftControlKeyset);

const displayIntentsTab = (skill: AliceApp) => skill.channel === Channel.AliceSkill;

const isYangoRequest = () => __appConfig.isYangoRequest;

export const useSettingsPageMenuItems = (skill: AliceApp, isDraft = false) => {
    const display: Record<SettingsTab, boolean> = {
        main: true,
        devices: skill.channel === Channel.SmartHome,
        intents: displayIntentsTab(skill),
        userAgreements: displayUserAgreements(),
    };
    const t = useI18N(keyset);
    const tApp = useI18N(appKeyset);
    const tAppForm = useI18N(appFormKeyset);

    const items: Array<MarkedMenuItem<SettingsTab>> = [
        {
            tab: 'main',
            path: `${routes.app.skillSettings(isDraft, 'main', skill.id)}#about`,
            title: tApp('about-skill'),
            exact: true,
        },
        {
            tab: 'intents',
            path: routes.app.skillSettings(isDraft, 'intents', skill.id),
            title: t('submenu-intents'),
            exact: true,
        },
        {
            tab: 'userAgreements',
            path: `${routes.app.skillSettings(isDraft, 'main', skill.id)}#user-agreements`,
            title: tAppForm('agreement'),
            exact: true,
        },
        {
            tab: 'main',
            path: `${routes.app.skillSettings(isDraft, 'main', skill.id)}#others`,
            title: tDraftControl('others'),
            exact: true,
        },
    ];

    if (!isYangoRequest()) {
        items.splice(1, 0, {
            tab: 'devices',
            path: routes.app.skillSettings(isDraft, 'devices', skill.id),
            title: t('submenu-devices'),
            exact: true,
        });
    }

    return useMenuItems(display, items);
};
